import auth from "../Middlewares/auth";

import Index from "../../Components/Pages/Documents/Index";

export const routes = [
    {
        path: '/documents',
        name: 'documents',
        component: Index,
        meta: {
            title: "Documents",
            menu: 'left',
            icon: 'mdi-file',
            middleware: [
                auth
            ],
        }
    }
]
